import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/professions/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointDelete: `${config.endpoints.backend}professions/delete`,
        endpoint: config.endpoints.backend + 'professions/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Profissões',
        labelTitleButtonAdd: 'Incluir nova profissão',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        formFilters: !profileFilter.pdc_entity_id ? filters : null,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'name',
                label: 'Nome da profissão',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
